module.exports = __webpack_public_path__ + "img/2.47e09dd0.png";